// extracted by mini-css-extract-plugin
export default {"container":"N7CJzJY8kXsnIO9cYystWg==","copy":"_3rfA8xlHKX100fGNc2AjqA==","linkExternal":"XYDHeaq5ToLZB9K22J30ug=="};